/** @module components/callouts/join-callout */
import baustein from "baustein";
import rothko from "web/script/modules/rothko";
import analytics from "web/script/analytics/analytics";
import template from "templates/modules/callouts/join_callout.jinja";
import userProfiler from "web/script/modules/userprofiler";

/**
 * Renders a join callout for users to signup.
 *
 * @constructor
 * @alias module:components/callouts/join-callout
 * @extends module:baustein
 */
export default baustein.register(
    "join-callout",
    /** @lends module:components/callouts/join-callout.prototype */
    {
        template,

        defaultOptions: {
            next: "/",
        },

        setupEvents(add) {
            add("click", ".join-callout__close-button", this._onCloseButtonClick);
        },

        getInitialRenderContext() {
            return {
                join_callout: {},
            };
        },

        onInsert() {
            analytics.event("signup_callout", "prompt_show", "signup_callout", true);
            const next = this.options.next;
            rothko.fetch("modules/callouts/join_callout", { next }).then((data) => {
                this.setRenderContext({
                    join_callout: data,
                    is_button: true,
                });
            });
        },

        _onCloseButtonClick() {
            userProfiler.setJoinOverlayShown();
            this.destroy();
        },
    }
);
